import { createFileRoute } from '@tanstack/react-router';
import { MerchantProfilePage } from '../../features/merchants/MerchantProfilePage.jsx';

function MerchantRoute() {
  const { merchantId } = Route.useParams();
  return <MerchantProfilePage key={merchantId} merchantId={merchantId} />;
}

export const Route = createFileRoute('/_app/merchants/$merchantId')({ component: MerchantRoute });
